let UniformStyle = require('./uniform');

const white = [255, 255, 255, 1];
const blue = [0, 153, 255, 1];
const width = 3;

let styleConfigurations = {};

styleConfigurations.Polygon = {
    fill: {
        color: [255, 255, 255, 0.5]
    },
    stroke: {
        width: width/2,
        color: blue
    }
};

styleConfigurations.MultiPolygon = styleConfigurations.Polygon;
styleConfigurations.LineString = {
    stroke: {
        color: blue,
        width: width/3
    }
};
styleConfigurations.MultiLineString = styleConfigurations.LineString;
styleConfigurations.Point = {
    image: {
        radius: width * 2,
        fill: {
            color: blue
        },
        stroke: {
            color: white,
            width: width / 2
        }
    }
};
styleConfigurations.MultiPoint = styleConfigurations.Point;

let defaultStyles = {
    "Point": new UniformStyle(styleConfigurations["Point"]),
    "MultiPoint": new UniformStyle(styleConfigurations["MultiPoint"]),
    "LineString": new UniformStyle(styleConfigurations["LineString"]),
    "MultiLineString": new UniformStyle(styleConfigurations["MultiLineString"]),
    "Polygon": new UniformStyle(styleConfigurations["Polygon"]),
    "MultiPolygon": new UniformStyle(styleConfigurations["MultiPolygon"]),
    "anyGeometryType": new UniformStyle(styleConfigurations["Point"]),
};

module.exports = defaultStyles;